import React, {Component} from "react";

class MonitorMeter extends Component {
    componentDidMount() {
    }

    colorPerPercent = (value) => {
        const colorValue = (value / 100);
        const hue = ((1 - colorValue ) * 120).toString(10);
        return ["hsl(",hue,",100%,50%)"].join("");
    };

    render() {
        const { max, value, type, unit, label = "label text" } = this.props;

        const degress = value * 180 / max;
        const degressType = type === "temp" ? (<React.Fragment>&#176;</React.Fragment>)  : null;
        let rotate = {
            transform: `rotate(${degress}deg)`,
        };


        return (
            <div className="gauge">
                <div className="gauge-text-small-widget">{label} [{degressType}{unit}]</div>
                <div className="gauge-body">
                    <div className="gauge-fill" style={rotate}> </div>
                    <div className="gauge-cover">
                        {value}{unit}
                    </div>
                </div>
            </div>
        );
    }
}
export default MonitorMeter;
